export default {
    mounted() {
        this.disableLoadingIfApple();
    },
    methods: {
        disableLoadingIfApple() {
            let vm = this;
            let isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
            let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            //Fix for using back-forward cache when navigating back, on Safari/iOS
            if(isSafari || iOS) {
                window.onpageshow = function(event) {
                    if(event.persisted) {
                        vm.emitter.emit('isLoading', false);
                    }
                };
            }
        }
    }
}